import { BellRing } from "lucide-react";

import SwitchLinha from "./SwitchLinha";

const DESCRICAO = {
  item_esgotado: "Produto ou categoria marcado como indisponível/escondido (inclui o esgotamento automático por estoque).",
  item_ativado: "Produto ou categoria que voltou a ficar disponível/visível.",
  loja_abre_fecha: "Quando a loja é aberta ou fechada.",
  loja_sem_confirmacao: "Loja fechada automaticamente por ninguém confirmar a abertura no horário.",
  caixa: "Abertura e fechamento do caixa, com o resumo.",
  pedido_cancelado: "Pedido cancelado ou pedido de cancelamento do cliente.",
  desconto: "Desconto manual aplicado em um pedido.",
  cupom: "Cupom de desconto usado em um pedido.",
  resumo_pedidos: "Todo pedido novo chega resumido no WhatsApp — ideal pra acompanhar sem computador.",
  estoque_minimo: "Item de estoque que bateu no mínimo, com quanto comprar para normalizar. Só itens com mínimo e máximo definidos.",
};

/** Controle > Quais alertas receber: um switch por tipo. */
export default function SecaoTiposAlerta({ tipos, prefs, onChange }) {
  return (
    <div className="bg-card border border-border rounded-lg p-6" data-e2e="secao-tipos">
      <div className="flex items-start gap-3 mb-4">
        <div className="p-2 rounded-lg bg-primary text-primary-foreground"><BellRing className="w-5 h-5" /></div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold">Quais alertas receber</h2>
          <p className="text-sm text-muted-foreground">Ligue só o que interessa. Vale para o número acima, com os avisos ativos.</p>
        </div>
      </div>
      <div className="space-y-2">
        {(tipos || []).map((t) => (
          <SwitchLinha key={t.chave} testId={`sw-${t.chave}`} titulo={t.rotulo} descricao={DESCRICAO[t.chave]}
            ligado={!!prefs?.[t.chave]} onChange={(x) => onChange({ ...prefs, [t.chave]: x })} />
        ))}
      </div>
    </div>
  );
}
